<template>
  <CDialog
    class="p-confirm-dialog-custom"
    v-model:visible="visible"
    :class="className"
    :closable="isClosable"
    :modal="true"
    :header="header"
    :blockScroll="blockScroll"
    :position="position"
    :breakpoints="breakpoints"
    @update:visible="
      (e) => {
        if (!e) {
          reject();
        }
      }
    "
  >
    <template #header v-if="$slots.title">
      <slot name="title"></slot>
    </template>
    
    <div v-if="$slots.icon" class="icon">
    </div>
    <!-- <span v-else-if="icon && icon.length > 1" class="icon">
      <i :class="icon"></i>
    </span> -->
    
    <span v-if="$slots.message" class="p-confirm-dialog-message">
      <slot name="message"></slot>
    </span>
    <span v-else class="p-confirm-dialog-message">{{ message }}</span>

    <div v-if="$slots.info" class="p-confirm-dialog-custom-info">
      <slot name="info"></slot>
    </div>

    <template #footer>
      <template v-if="isButton">
        <CDButton
          v-if="!isConfirm"
          :label="rejectLabel"
          :icon="rejectIcon"
          :class="rejectClass"
          @click="reject()"
          class="reject-button -button -waikawaGrey"
        />
        <CDButton
          :label="acceptLabel"
          :icon="acceptIcon"
          :class="acceptClass"
          @click="accept()"
          class="accept-button -button -royalBlue"
          autofocus
        />
      </template>
      <template v-else>
        <slot name="footer"></slot>
      </template>
    </template>
  </CDialog>
</template>

<script>
/**
 * title, message 추가
 */
import ConfirmationEventBus from "primevue/confirmationeventbus";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
  name: "ConfirmDialog",
  props: {
    group: String,
    breakpoints: {
      type: Object,
      default: null,
    },
    isClosable: {
      type: Boolean,
      default: true,
    },
    className:String,
    isConfirm: Boolean, // true : 확인 버튼, false : 아니오 / 예 버튼
    isButton: {
      type: Boolean,
      default: true,
    },
  },
  confirmListener: null,
  closeListener: null,
  data() {
    return {
      visible: false,
      confirmation: null,
    };
  },
  mounted() {
    //console.log(this.isClosable, 'ConfirmDialog.isClosable');

    this.confirmListener = (options) => {
      
      console.log(options, 'this.confirmListener.options');
      console.log(this.group, 'this.confirmListener.this.group');

      if (!options) {
        return;
      }

      //console.trace(options, 'ConfirmDialog.confirmListener.options');
      if (options.group === this.group) {
        this.confirmation = options;
        this.visible = true;
        console.log(this.visible, 'this.confirmListener.this.visible');
      }
    };

    this.closeListener = () => {
      this.visible = false;
      this.confirmation = null;
    };
    ConfirmationEventBus.on("confirm", this.confirmListener);
    ConfirmationEventBus.on("close", this.closeListener);
    
  },
  beforeUnmount() {
    ConfirmationEventBus.off("confirm", this.confirmListener);
    ConfirmationEventBus.off("close", this.closeListener);
  },
  methods: {
    accept() {
      if (this.confirmation.accept) {
        this.confirmation.accept();
      }

      this.visible = false;
    },
    reject() {
      if (this.confirmation.reject) {
        this.confirmation.reject();
      }

      this.visible = false;
    },
  },
  computed: {
    dialogClass() {
      return this.className;
    },
    header() {
      return this.confirmation ? this.confirmation.header : null;
    },
    message() {
      return this.confirmation ? this.confirmation.message : null;
    },
    blockScroll() {
      return this.confirmation ? this.confirmation.blockScroll : true;
    },
    position() {
      return this.confirmation ? this.confirmation.position : null;
    },
    icon() {
      return [
        "p-confirm-dialog-icon",
        this.confirmation ? this.confirmation.icon : null,
      ];
    },
    acceptLabel() {
      return this.confirmation
        ? this.confirmation.acceptLabel || this.$primevue.config.locale.accept
        : null;
    },
    rejectLabel() {
      return this.confirmation
        ? this.confirmation.rejectLabel || this.$primevue.config.locale.reject
        : null;
    },
    acceptIcon() {
      return this.confirmation ? this.confirmation.acceptIcon : null;
    },
    rejectIcon() {
      return this.confirmation ? this.confirmation.rejectIcon : null;
    },
    acceptClass() {
      return [
        "p-confirm-dialog-accept",
        this.confirmation ? this.confirmation.acceptClass : null,
      ];
    },
    rejectClass() {
      return [
        "p-confirm-dialog-reject",
        this.confirmation
          ? this.confirmation.rejectClass || "p-button-text"
          : null,
      ];
    },
  },
  components: {
    CDialog: Dialog,
    CDButton: Button,
  },
};
</script>
<style lang="scss">
@import "@/styles/mixin";

.p-dialog.dialog-alert {
  z-index: 3000;

  .p-dialog-content {
    display: flex;
    align-items:center;
    .icon {
      >i {
        font-size: 2rem !important;
        margin-right: 0.25rem;
        &.pi-exclamation-triangle {
          color: $BrinkPink;
        }
      }
    }
  }
}

.center-align-dialog {
  &.p-dialog {
    text-align: center;
    max-width: 480px !important;
    .p-dialog-content {
      text-align: center;
      .icon {
        >img {
          width: 48px;
        }
        padding: 12px;
        >i {
          .pi-exclamation-triangle {
            font-size: 2rem !important;
          }
        }
      }
      .p-confirm-dialog-message {

        color: #232325 !important;
        font-size: 20px;
        font-weight: 700;
      }
    }
    .p-dialog-footer {
      display: flex;
      border: none !important;
      padding: 16px 32px 32px 32px;
      >button {
        flex-grow: 1;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
